export default {
  selectedEventStatus: state => state.selectedEventStatus
}
